<template>
  <v-menu attach :nudge-left=vMenuWidth offset-y :close-on-content-click="false" :min-width="240" transition="scale-transition" v-model="isMenuOpen" ref="vMenu">
    <v-btn id="desktop_account_menu" icon slot="activator" @click="calcvMenuWidth()">
      <v-icon class="primary-text">mdi-account</v-icon>
    </v-btn>
    <v-list id="desktop_account_menu_list">
      <v-list-tile avatar class="mt-1">
        <v-list-tile-content>
          <v-layout row align-content-space-between justify-space-between style="width: 100%">
            <v-icon class="pr-2">mdi-message-text</v-icon>
            <v-select id="desktop_account_language"
                      class="select-header-menu"
                      :items="getLanguageDescriptions"
                      :label="$t('language_select_label')"
                      :value="getCurrentLanguageDescription"
                      @change="languageChanged"
                      attach
                      content-class="desktop-account-languages"/>
          </v-layout>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-if="loggedIn && isAdmin"></v-divider>
      <v-subheader v-if="loggedIn && isAdmin" class="text--lighten-4">{{$t('admin.area')}}</v-subheader>
      <v-list-tile id="settings_menu" class="pt-1 pb-1" v-if="loggedIn && isAdmin && flagEnableAlerts" @click="navigateToAlertsSettings">
        <v-list-tile-content>
          <v-list-tile-title>
            <v-icon class="pr-2">alarm</v-icon>
            {{$t('admin.alerts.alerts')}}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile id="settings_menu" class="pt-1 pb-1" v-if="loggedIn && isAdmin" @click="navigateToAnnouncementsSettings">
        <v-list-tile-content>
          <v-list-tile-title>
            <v-icon class="pr-2">announcement</v-icon>
            {{$t('admin.announcements')}}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-if="loggedIn && isAdmin"></v-divider>
      <v-list-tile id="dark_theme" class="pt-1 pb-1">
        <v-switch
          :label="$t('dark_theme')" hide-details
          v-model="darkTheme"
        />
      </v-list-tile>
      <template v-if="loggedIn">
        <v-divider></v-divider>
        <v-list-tile id="desktop_account_logout"  class="pt-1 pb-1" @click="logout">
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon class="pr-2">mdi-logout</v-icon>
              {{$t('logout')}}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { LOGOUT } from '../../store/action-types'
  import { HAS_FEATURE_FLAG, IS_ADMIN } from '../../store/getter-types'
  import { SET_ANNOUNCEMENTS, SET_PROFILE_DARK_THEME } from '../../store/mutation-types'

  export default {
    name: 'personal-menu',
    data () {
      return {
        isMenuOpen: false,
        vMenuWidth: 205
      }
    },
    methods: {
      logout () {
        this.isMenuOpen = false
        this.$store.commit(SET_ANNOUNCEMENTS, [])
        this.doLogout()
        if (!this.$store.state.config.useSSO && !this.$store.state.config.useSAML) {
          this.$router.push({name: 'Login'})
        } else {
          window.location.replace(this.$store.state.config.authUrlLogOut)
        }
      },
      languageChanged (description) {
        this.isMenuOpen = false
        const locale = this.getFromDesc(description)
        this.$i18n.set(locale)
      },
      ...mapActions({
        'setLanguageFromDescription': 'setLanguageFromDescription',
        doLogout: LOGOUT
      }),
      navigateToAlertsSettings () {
        this.$router.push('/admin/alerts')
        this.isMenuOpen = false
      },
      navigateToAnnouncementsSettings () {
        this.$router.push('/admin/announcements')
        this.isMenuOpen = false
      },
      calcvMenuWidth () {
        if (this.$refs.vMenu.dimensions.content.width < 240) {
          this.vMenuWidth = 205
        } else { this.vMenuWidth = this.$refs.vMenu.dimensions.content.width - 35 }
      }
    },
    computed: {
      ...mapState({
        moduleAlert: state => state.profile.module.alert,
        functionAdminMenu: state => state.profile.functions.adminMenu,
        optionEnableAlerts: state => state.profile.options.enable.alerts
      }),
      ...mapGetters([
        'getCurrentLanguageDescription',
        'getLanguageDescriptions'
      ]),
      ...mapGetters({
        isAdmin: IS_ADMIN,
        getFromDesc: 'getLanguageFromDescription',
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      darkTheme: {
        get () {
          return this.$store.state.profile.darkTheme
        },
        set (value) {
          this.$store.commit(SET_PROFILE_DARK_THEME, value)
        }
      },
      loggedIn () {
        return this.$store.state.profile.loggedIn
      },
      flagEnableAlerts () {
        // Alerting/Admin Menu/Enable Alerts
        return this.hasFeatureFlag(this.moduleAlert + '.' + this.functionAdminMenu + '.' + this.optionEnableAlerts)
      }
    }
  }
</script>

<style scoped>
#desktop_account_language >>> label {
  max-width: 100%;
}
#desktop_account_menu_list >>> .list__tile__content {
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/PersonalMenu.vue